import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getDataTypeList = () =>
  axiosInstance.get(API_ENDPOINTS.getDataTypeList);

export const getParseDataTypeList = () =>
  axiosInstance.get(API_ENDPOINTS.getParseDataTypeList);
